module.exports = __webpack_public_path__ + "img/b.c62164c8.jpg";